<template>
  <div class="pageSUNdetail">
    <XR-head titleText="交易明细" :rightShow="false"></XR-head>
    <div class="detail-traceAmt" v-if="!loaded">
        <span class="amt">{{SUNStream.Operater+SUNStream.TraceAmt}}</span>
    </div>
    <div class="row-list" v-if="!loaded">        
      <div class="row-item">
          <p class="item-title">发款方</p>
          <p class="item-value">{{SUNStream.ExpensesAddress}}</p>
      </div>
              
      <div class="row-item">
          <p class="item-title">收款方</p>
          <p class="item-value">{{SUNStream.IncomeAddress}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">交易类型</p>
          <p class="item-value">{{SUNStream.TraceTypeName}}</p>
      </div>
      <div class="row-item">
          <p class="item-title">备注</p>
          <p class="item-value">{{SUNStream.Desc}}</p>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data() {
    return {
        loaded:true,
        SUNStream:{}
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    
    if(!this.$route.query.traceNo){
        return
    }
    this.getSUNStream()
  },
  methods: {
      getSUNStream: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetSUNStream",
        JSON.stringify({traceNo:this.$route.query.traceNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.SUNStream = res.Data;
          ths.loaded = false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .pageSUNdetail{
    background: white;
}
.pageSUNdetail .detail-traceAmt {
    overflow:hidden;
    text-align:center;
    margin: 0 20px;
    border-bottom:1px solid #efefef;
    padding:35px 0 35px;
}
    .pageSUNdetail .detail-traceAmt .amt {
        font-size:30px;
    }
    .pageSUNdetail .detail-traceAmt .unit {
        font-size:12px;
        color:#aaa;
    }
.pageSUNdetail .row-list {
    margin: 0 20px;
    padding:30px 0;
}
   .pageSUNdetail  .row-list .row-item {
        padding:10px 0;
    }
      .pageSUNdetail   .row-list .row-item .item-title {
            color:#ccc;
            font-size:16px;
        }
       .pageSUNdetail  .row-list .row-item .item-value {
            font-size:12px;
            padding-top:2px;
            word-break: break-all;
        }
    .pageSUNdetail .row-list.last {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/sunDetail.vue